import React from 'react';
import classnames from 'classnames';

import { VisuallyHiddenText } from 'shared/legacy';
import stylesheet from './Avatar.scss';

const Avatar = ({ firstname, lastname, url, src, size = '' }) => {
  const avatarClass = classnames(stylesheet.avatar, {
    [stylesheet[`avatar--${size}`]]: size,
  });

  //@TODO convert div on line 32 to Fragment when React 16 is used in the DS
  let imgOrInitial = src ? (
    <img
      className={stylesheet.avatar__image}
      alt={`${firstname || ''} ${lastname || ''}`}
      src={src}
    />
  ) : (
    <span>
      {firstname ? firstname[0] : ''}
      <VisuallyHiddenText text={`${firstname || ''} ${lastname || ''}`} />
    </span>
  );

  if (url) {
    imgOrInitial = (
      <a href={url} className={stylesheet.avatar__link}>
        {imgOrInitial}
      </a>
    );
  }

  return <div className={avatarClass}>{imgOrInitial}</div>;
};

export default Avatar;
